import { doubleEncode, makePutRequest } from "../../utils";

type RecoverASingleRecordingOptions = {
	sessionId: string;
	recordingId: string;
};
const recoverASingleRecording = async (
	token: string,
	options: RecoverASingleRecordingOptions,
) => {
	await makePutRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"recordings",
			options.recordingId,
			"status",
		],
		options: {},
		body: {
			action: "recover",
		},
	});
	return 204;
};

export const curriedRecoverASingleRecording = (token: string) => (
	options: RecoverASingleRecordingOptions,
) => recoverASingleRecording(token, options);